<section>
    <h5 class="font-secondary mb-4">{{data.title}} </h5>
    <p> {{data.content}}</p>
    <div class="text-end pt-1 font-secondary">
      
      <button class="btn btn-outline-dark py-2 px-4 rounded-pill me-2" (click)="close()">close</button>
      
    </div>
  </section>
